import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Col, Row, Space, Typography } from 'antd';
import { capitalizeWords } from '~/utils/validateCharacters';

function Guidance(props: any) {
  const { hierarchyLevels } = props;
  const { t } = useTranslation();
  const [colSpan, setColSpan] = useState<any>(4);
  useLayoutEffect(() => {
    const colSpanNum = 24 / hierarchyLevels.length;
    setColSpan(colSpanNum);
  }, [hierarchyLevels]);

  const levelsColors = {
    company: '#2375ef',
    region: '#23EFA6',
    branch: '#A123EF',
    department: '#EFCE23',
    cardholder: '#EF6023',
  };

  function titleHandler(item: any) {
    if (item === 'company') {
      return `Company legal name`;
    }
    if (item === 'cardholder') {
      return `Add Individual
      Cardholder`;
    }
    return `${String(item[0].toUpperCase()) + String(item.substring(1))} name`;
  }
  function descriptionHandler(item: any, index: number) {
    if (item === 'company') {
      return `Company name is not editable`;
    }
    if (item === 'cardholder') {
      return `Min 1 cardholder
      under every
      ${hierarchyLevels[hierarchyLevels.length - 2]}`;
    }
    return `Hierarchy ${Number(index) + 2} won’t
    be enabled unless
    you enter ${item}
    Name`;
  }

  function NoteHandler() {
    const arrOfNotes = [];
    for (let i = 0; i < hierarchyLevels.length; i++) {
      if (!hierarchyLevels[i + 1]) {
        break;
      }
      if (i === hierarchyLevels?.length - 3) {
        arrOfNotes.push(`multiple ${hierarchyLevels[i + 1]}s under a ${hierarchyLevels[i]} and `);
      } else {
        arrOfNotes.push(`multiple ${hierarchyLevels[i + 1]}s under each ${hierarchyLevels[i]}, `);
      }
    }
    const noteData = arrOfNotes.join('').slice(0, -2);

    return `You can add ${noteData}. Note there must be at least one entry under a hierarchy before moving to the next level.`;
  }
  return (
    <Container>
      <Space style={{ width: '100%' }} size={45} direction="vertical">
        <Typography.Title style={{ padding: '20px' }} level={5}>
          {capitalizeWords(t('Information & guidance for hierarchy levels.'))}
        </Typography.Title>
        <Row justify="center" gutter={14}>
          {hierarchyLevels?.map((item: any, index: any) => {
            return (
              <SectionContainer levelsColors={levelsColors} item={item} key={`${item}-Container`}>
                <Col key={item}>
                  <div className="rectanngleDiv">
                    <div className="CircleDiv">
                      <p className="NumberDiv">0{Number(index) + 1}</p>
                    </div>
                    <div
                      style={{ width: '100%', height: '100%', padding: '6px', textAlign: 'center', marginTop: '45px' }}
                    >
                      <Typography.Title level={5} style={{ fontSize: '13px', marginBottom: 0 }}>
                        {capitalizeWords(titleHandler(item))}
                      </Typography.Title>
                      <Typography.Paragraph>{descriptionHandler(item, index)}</Typography.Paragraph>
                    </div>
                  </div>
                </Col>
              </SectionContainer>
            );
          })}
        </Row>
      </Space>
      <div style={{ marginTop: '10px', padding: '20px' }}>
        <Typography.Paragraph>
          <strong> Note:</strong> {NoteHandler()}
        </Typography.Paragraph>
      </div>
    </Container>
  );
}
const Container = styled.div<any>`
  width: 100%;
  margin-top: 24px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
  /* height: 395px; */
`;
const SectionContainer = styled.div<any>`
  .rectanngleDiv {
    /* width: 100%; */
    width: 150px;
    height: 175px;
    flex-shrink: 0;
    /* height: 75px; */
    flex-shrink: 0;
    border-radius: 14px;
    /* width: 150px; */
    height: 175px;
    flex-shrink: 0;
    border: 3px solid ${({ item, levelsColors }) => levelsColors[item]};
    background: #fff;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
  }
  .CircleDiv {
    width: 100px;
    height: 100px;
    background-color: ${({ item, levelsColors }) => levelsColors[item]};
    position: absolute;
    border-radius: 100px;
    top: -50px;
    left: 20%;
    text-align: center;
    align-self: center;
    align-content: center;
    align-items: 'center';
  }
  .NumberDiv {
    margin-top: 25px;
    color: #fff;
    font-family: Gotham;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 60% */
  }
`;
export default Guidance;
